module.exports = __webpack_public_path__ + "img/customer_03.664d529e.jpg";